module.exports = __webpack_public_path__ + "resources/img/certi_iso_iec_27001.43f621d514a3a7f19417898fccc2d04e.png";